import { Outlet, createFileRoute } from '@tanstack/react-router'

import { ShelfShell } from '@/features/shelf/ShelfShell'

export const Route = createFileRoute('/shelf')({ component: ShelfLayout })

function ShelfLayout() {
  return (
    <ShelfShell>
      <Outlet />
    </ShelfShell>
  )
}
